import { DATE_FORMATS, DateTime } from "@bps/date-time";
import { TooltipHost } from "@bps/fluent-ui";
import { getDurationSinceNowHumanized } from "@libs/common/common.utils";

interface DateTimeWithDurationSinceTooltipProps {
  dateUtc: DateTime | undefined;
}

export const DateTimeWithDurationSinceTooltip = ({
  dateUtc
}: DateTimeWithDurationSinceTooltipProps) => {
  if (!dateUtc) return null;

  const humanizedTooltip = getDurationSinceNowHumanized(dateUtc);

  const tooltipText = `${humanizedTooltip} ago`;

  return (
    <TooltipHost content={tooltipText}>
      {dateUtc.toFormat(DATE_FORMATS.LONG_DATE_FORMAT_MONTH_AHEAD_CUT)}
    </TooltipHost>
  );
};
